import * as React from 'react';
import {ROUTE_ADMIN_FORMS} from "../../../../routing/Routes";
import FormListCardAdmin from "./FormListCardAdmin";
import I18nUtils from "../../../../I18n/I18nUtils";
import {TR_FORMULARIOS} from "../../../../I18n/constants";
import {MenuIcon} from "../../../../Config";
import ScreenCard from '../../../../components/screen/ScreenCard';

export default class FormListAdminScreen extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <ScreenCard breadcrumbs={[
                {
                    name: I18nUtils.tr(TR_FORMULARIOS),
                    url: ROUTE_ADMIN_FORMS,
                    icon: MenuIcon.FORM
                }
            ]}>
                <FormListCardAdmin/>
            </ScreenCard>
        )
    }
}
